import React from "react"
import { useSignal } from "@preact/signals-react"
import { IconSeeker } from "@ui-seeker/core"

import {favFilterSelected} from "@signals"
import useFavFilterModal from "./@hooks/useFavFilterModal"
import {Box} from "@mui/material";


export default function FavFiltersIcon({ isOpenFavModal, dashboardKey }) {

    const { getFavouriteFilters, setFilterDefaultInDashboard } = useFavFilterModal()

    return <Box display="flex">
        {!!favFilterSelected.value && <IconSeeker
            icon='star'
            color='info.light'
            iconWeight={favFilterSelected.value?.defaultFilter ? 'solid' : 'regular'}
            onClick={() => {
                setFilterDefaultInDashboard(dashboardKey, favFilterSelected.value?.filterID, true)
            }}
            disabled={!!favFilterSelected.value}
            tooltip={favFilterSelected.value?.defaultFilter ?
                'Delete Filter as default in this Dashboard'
                : 'Set Filter as default in this Dashboard'}
            sx={{ mr: 2, '&:hover': { cursor: 'pointer' } }}
        />}
         <IconSeeker
            icon='floppy-disk'
            color='info.light'
            onClick={() => {
                getFavouriteFilters(dashboardKey)
                isOpenFavModal.value = true
            }}
            tooltip="Save this filters as a group of favorites"
            sx={{ mr: 2, '&:hover': { cursor: 'pointer' } }}
        />
    </Box>
}